import React from "react";
import { FlightTakeoff, FlightLand } from "@material-ui/icons";

const getStatusClass = (status) => {
  const normalized = (status || "").toLowerCase();
  if (normalized.includes("delay")) {
    return "rate-analysis-flight-status-delayed";
  }
  if (normalized.includes("cancel")) {
    return "rate-analysis-flight-status-cancelled";
  }
  if (normalized.includes("on time") || normalized === "scheduled" || normalized === "normal") {
    return "rate-analysis-flight-status-ontime";
  }
  return "rate-analysis-flight-status-default";
};

const FlightDetailsCard = ({ flightDetails, flightLandTime }) => {
  if (!flightDetails) {
    return null;
  }

  const { airline, flightNo, status, departure, arrival } = flightDetails;

  return (
    <div className="rate-analysis-flight-card">
      <div className="rate-analysis-flight-card-header">
        <div className="rate-analysis-flight-airline">
          {airline?.logo && (
            <img
              src={airline.logo}
              alt={airline.name}
              className="rate-analysis-flight-airline-logo"
            />
          )}
          <div>
            <p className="rate-analysis-flight-number">{flightNo}</p>
            <p className="rate-analysis-flight-airline-name">
              {airline?.name || "—"}
            </p>
          </div>
        </div>
        {status && (
          <span
            className={`rate-analysis-flight-status ${getStatusClass(status)}`}
          >
            {status}
          </span>
        )}
      </div>

      <div className="rate-analysis-flight-route">
        <div className="rate-analysis-flight-leg">
          <div className="rate-analysis-flight-leg-icon">
            <FlightTakeoff />
          </div>
          <div className="rate-analysis-flight-leg-info">
            <p className="rate-analysis-flight-leg-label">Departure</p>
            <p className="rate-analysis-flight-airport-code">
              {departure?.airportCode}
            </p>
            <p className="rate-analysis-flight-airport-name">
              {departure?.airportName}
            </p>
            <div className="rate-analysis-flight-times">
              <span>
                Scheduled: <strong>{departure?.scheduledFormatted}</strong>
              </span>
              {departure?.actual && departure.actual !== departure.scheduled && (
                <span>
                  Actual: <strong>{departure?.actualFormatted}</strong>
                </span>
              )}
            </div>
          </div>
        </div>

        <div className="rate-analysis-flight-route-line">
          <span className="rate-analysis-flight-route-dot" />
          <span className="rate-analysis-flight-route-dash" />
          <span className="rate-analysis-flight-route-dot" />
        </div>

        <div className="rate-analysis-flight-leg">
          <div className="rate-analysis-flight-leg-icon rate-analysis-flight-leg-icon-arrival">
            <FlightLand />
          </div>
          <div className="rate-analysis-flight-leg-info">
            <p className="rate-analysis-flight-leg-label">Arrival</p>
            <p className="rate-analysis-flight-airport-code">
              {arrival?.airportCode}
            </p>
            <p className="rate-analysis-flight-airport-name">
              {arrival?.airportName}
            </p>
            <div className="rate-analysis-flight-times">
              <span>
                Scheduled: <strong>{arrival?.scheduledFormatted}</strong>
              </span>
              {arrival?.actual && arrival.actual !== arrival.scheduled && (
                <span>
                  Actual: <strong>{arrival?.actualFormatted}</strong>
                </span>
              )}
            </div>
          </div>
        </div>
      </div>

      {flightLandTime && (
        <div className="rate-analysis-flight-land-time">
          <span className="rate-analysis-flight-land-label">Flight land time</span>
          <span className="rate-analysis-flight-land-value">{flightLandTime}</span>
        </div>
      )}
    </div>
  );
};

export default FlightDetailsCard;
